package dev.krno

import org.jetbrains.compose.web.renderComposable

fun main() {
    printConsoleGreeting()
    renderComposable(rootElementId = "root") { App() }
}

// A little wink for the curious dev who opens DevTools. Uses %c format slots
// to color the ASCII art in the Kotlin palette. Not an easter egg for the
// UI — just a signature of who built the page and where to find the meetup.
private fun printConsoleGreeting() {
    val art = """
         ___  ___  _  _ _  _____
        | _ )| _ \| \| | |/ / _ \
        | _ \|   /| .` | ' < (_) |
        |___/|_|_\|_|\_|_|\_\___/
    """.trimIndent()
    val cssBig = "color:#F88909;background:#0A0A0A;font-family:monospace;font-size:13px;font-weight:700;line-height:1.15;padding:6px 10px;"
    val cssSub = "color:#8A8494;font-family:monospace;font-size:12px;padding:6px 10px 0;"
    val cssLink = "color:#F88909;font-family:monospace;font-size:12px;padding:0 10px 6px;"
    console.log(
        "%c$art%c\nWritten in Kotlin · Compose HTML%c\nCurious? Kotlin meetup #1 · 24. 11. 2026 · https://brnko.cz",
        cssBig,
        cssSub,
        cssLink,
    )
}
